
<template>
  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Unit Economics</h1>
    </div>
    <div v-show="progress.stage_five === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">Data Request</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Prior to our first call please fill out this questionnaire</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Click on the save draft button to save your progress</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">10mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="contain">
              <!-- <div v-show="windowWidth > 768" class="progress-bar relative">
                <div class="line w-[87%] bg-lineGray h-[2px] absolute mx-3 left-7 top-[7.5px]"></div>
                <div class="step flex flex-col items-center">
                  <div class="bullet active">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Market</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Financials</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Schedule Meeting</p>
                </div>
              </div> -->
              <div class="progress relative bg-faintGrey rounded-[4px] py-3 px-4 mb-8">
                <div class="current-progress relative flex items-center justify-between active">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Market
                  </div>
                  <div class="max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="text-black">1</span> of 3
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Financials
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">2</span> of 3
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Schedule Meeting
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">3</span> of 3
                  </div>
                </div>
                <!-- <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Fundraise
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">4</span> of 5
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Schedule Meeting
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">5</span> of 5
                  </div>
                </div> -->
              </div>
              <div>
                <div class="form-outer">
                  <div class="forms">
                    <div class="page slide-page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="customer-aquisition"
                        >
                          <span class="text-red-400">*</span>
                          What is the cost of acquiring a customer?
                        </label>
                        <textarea
                          id="customer-aquisition"
                          name="customer-aquisition"
                          type="text"
                          rows="3"
                          :class="[
                          v$.customer_aquisition.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. sales and marketing spend $100,000 last month, 1,000 activated users, CAC = $10 per user"
                          style="transition: 'all .15s ease'"
                          v-model="v$.customer_aquisition.$model"
                          @blur="v$.customer_aquisition.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.customer_aquisition.length} of 400`}}</span>
                        <div v-if="v$.customer_aquisition.$error">
                          <p
                            v-if="v$.customer_aquisition.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Customer aquisition is required</p>
                          <p
                            v-if="v$.customer_aquisition.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Customer aquisition should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="customer-value"
                        >
                          <span class="text-red-400">*</span>
                          What is the projected lifetime value of a consumer?
                        </label>
                        <textarea
                          id="customer-value"
                          name="customer-value"
                          type="text"
                          rows="3"
                          :class="[
                          v$.customer_value.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. We calculate a contribution margin per customer each year of $10, and with expected churn of 25%, minus acquisition cost of $15, to get CLTV of $25"
                          style="transition: 'all .15s ease'"
                          v-model="v$.customer_value.$model"
                          @blur="v$.customer_value.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.customer_value.length} of 400`}}</span>
                        <div v-if="v$.customer_value.$error">
                          <p
                            v-if="v$.customer_value.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Customer value is required</p>
                          <p
                            v-if="v$.customer_value.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Customer value should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative flex md:justify-end justify-between w-full mb-6">
                        <button
                          class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
                          @click="onSaveDraft"
                        >
                          Save draft
                        </button>
                        <button :disabled="checkValidForm(v$, 'Market')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50" @click="goToStep2">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="flex justify-between font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
                        >
                          Upload Financial Model (If available)
                        </label>
                        <div v-if="financialModelFile" class="flex md:items-center items-start md:flex-row flex-col relative">
                          <label for="financialmodel-file-upload" class="flex flex-nowrap items-center justify-center px-2 py-3 w-[40%] relative cursor-pointer bg-white font-Rubik text-black rounded-sm border border-dashed focus:outline-none focus:border-black hover:border-black focus:ring-0">
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                            </span>
                            Upload a File
                            <input id="financialmodel-file-upload" name="financialmodel-file-upload" type="file" class="sr-only"
                              @change="choosefile($event, 'financial_model_file_upload', 'FINANCIAL')"
                              :disabled="loading.state" />
                          </label>
                          <!-- loader -->
                          <svg v-if="loading.state && loading.data === 'financial_model_file_upload'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                            </circle>
                          </svg>
                          <div v-else class="md:ml-5 md:mt-0 mt-4 ml-0 text-blueLink flex items-center justify-between flex-nowrap md:w-[60%] w-full">
                            <span v-if="data.financial_model_file_upload" class="mr-3">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_487_4554)">
                                  <path d="M1.80078 1.8C1.80078 0.805888 2.60667 0 3.60078 0H10.8008C11.0395 0 11.2684 0.0948211 11.4372 0.263604L15.9372 4.7636C16.106 4.93239 16.2008 5.1613 16.2008 5.4V16.2C16.2008 17.1941 15.3949 18 14.4008 18H3.60078C2.60667 18 1.80078 17.1941 1.80078 16.2V1.8ZM14.028 5.4L10.8008 2.17279V5.4H14.028ZM9.00078 1.8L3.60078 1.8V16.2H14.4008V7.2H9.90078C9.40372 7.2 9.00078 6.79706 9.00078 6.3V1.8ZM5.40078 9.9C5.40078 9.40294 5.80372 9 6.30078 9H11.7008C12.1978 9 12.6008 9.40294 12.6008 9.9C12.6008 10.3971 12.1978 10.8 11.7008 10.8H6.30078C5.80372 10.8 5.40078 10.3971 5.40078 9.9ZM5.40078 13.5C5.40078 13.0029 5.80372 12.6 6.30078 12.6H11.7008C12.1978 12.6 12.6008 13.0029 12.6008 13.5C12.6008 13.9971 12.1978 14.4 11.7008 14.4H6.30078C5.80372 14.4 5.40078 13.9971 5.40078 13.5Z" fill="#187CB4"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_487_4554">
                                    <rect width="18" height="18" fill="white"/>
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <div class="flex items-center justify-between w-full relative">
                              <p class="font-Rubik">{{ data.financial_model_file_upload }}</p>
                              <span v-if="data.financial_model_file_upload" @click="removefile('financial_model_file_upload')" class="flex items-center pr-4 mt-2">
                                <svg class="h-5 w-5 text-originsRed cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <!-- <input
                          v-if="!financialModelFile"
                          id="financialmodel-file-upload"
                          name="financialmodel-file-upload"
                          type="text"
                          v-model="data.financial_model_file_upload"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Link to financial model"
                          style="transition: 'all .15s ease'"
                        /> -->
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="keyassumptions"
                        >
                          <span class="text-red-400">*</span>
                          What are the key assumptions driving your financial projections?
                        </label>
                        <textarea
                          id="keyassumptions"
                          name="keyassumptions"
                          type="text"
                          rows="3"
                          :class="[
                          v$.financial_assumptions.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. The key assumption that drives our projections is our customer acquisition model and then our ability to improve margins with increased operational efficiency"
                          style="transition: 'all .15s ease'"
                          v-model="v$.financial_assumptions.$model"
                          @blur="v$.financial_assumptions.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.financial_assumptions.length} of 400`}}</span>
                        <div v-if="v$.financial_assumptions.$error">
                          <p
                            v-if="v$.financial_assumptions.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Financial assumptions is required</p>
                          <p
                            v-if="v$.financial_assumptions.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Financial assumptions should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="breakeven"
                        >
                          <span class="text-red-400">*</span>
                          When will the company reach profitability? In other words, how long will it take for the firm to reach profitability. If possible include the company's EBIT break-even point
                        </label>
                        <textarea
                          id="breakeven"
                          name="breakeven"
                          type="text"
                          rows="3"
                          :class="[
                          v$.profitability.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. We anticipate that we will be profitable in 18 months"
                          style="transition: 'all .15s ease'"
                          v-model="v$.profitability.$model"
                          @blur="v$.profitability.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.profitability.length} of 400`}}</span>
                        <div v-if="v$.profitability.$error">
                          <p
                            v-if="v$.profitability.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Break even is required</p>
                          <p
                            v-if="v$.profitability.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Break even should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="churnrate"
                        >
                          <span class="text-red-400">*</span>
                          What is the customer churn rate over the past 12 months?
                        </label>
                        <textarea
                          id="churnrate"
                          name="churnrate"
                          type="text"
                          rows="3"
                          :class="[
                          v$.churn_rate.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="We’ve experienced roughly 3% churn annualized in our customer base"
                          style="transition: 'all .15s ease'"
                          v-model="v$.churn_rate.$model"
                          @blur="v$.churn_rate.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.churn_rate.length} of 100`}}</span>
                        <div v-if="v$.churn_rate.$error">
                          <p
                            v-if="v$.churn_rate.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Churn rate is required</p>
                          <p
                            v-if="v$.churn_rate.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Churn rate should be at least 3 characters long</p>
                        </div>
                      </div>
                      <label
                        class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                      >
                        What is the company's burn rate and cash on hand? How much runway (in months) does the company have with the current cash on hand?
                      </label>
                      <div class="relative w-full mb-6 mt-2">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="burnrate"
                        >
                          <span class="text-red-400">*</span>
                          BURN RATE (Amt in $)
                        </label>
                        <input
                          id="burnrate"
                          name="burnrate"
                          type="number"
                          :class="[
                          v$.burn_rate.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. $0 (if profitable)"
                          style="transition: 'all .15s ease'"
                          v-model="v$.burn_rate.$model"
                          @blur="v$.burn_rate.$touch()"
                        />
                        <div v-if="v$.burn_rate.$error">
                          <p
                            v-if="v$.burn_rate.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Burn rate is required</p>
                          <p
                            v-if="v$.burn_rate.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.burn_rate.minValueValue.$message}}</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="cashonhand"
                        >
                          <span class="text-red-400">*</span>
                          CASH ON HAND ($)
                        </label>
                        <input
                          id="cashonhand"
                          name="cashonhand"
                          type="number"
                          :class="[
                          v$.cash_on_hand.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. $200k cash on hand"
                          style="transition: 'all .15s ease'"
                          v-model="v$.cash_on_hand.$model"
                          @blur="v$.cash_on_hand.$touch()"
                        />
                        <div v-if="v$.cash_on_hand.$error">
                          <p
                            v-if="v$.cash_on_hand.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Cash on hand is required</p>
                          <p
                            v-if="v$.cash_on_hand.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.cash_on_hand.minValueValue.$message}}</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="runway"
                        >
                          <span class="text-red-400">*</span>
                          RUNWAY (Months)
                        </label>
                        <input
                          id="runway"
                          name="runway"
                          type="number"
                          :class="[
                          v$.runway.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g. 18 months of runway"
                          style="transition: 'all .15s ease'"
                          v-model="v$.runway.$model"
                          @blur="v$.runway.$touch()"
                        />
                        <div v-if="v$.runway.$error">
                          <p
                            v-if="v$.runway.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Runway is required</p>
                          <p
                            v-if="v$.runway.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.runway.minValueValue.$message}}</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                          <span class="text-red-400">*</span>
                          Does the company have multiple revenue streams?</label>
                        <fieldset class="mt-4">
                          <legend class="sr-only">Does the company have multiple revenue streams?</legend>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center md:ml-2 ml-0">
                              <input id="yes" name="notification-method" type="radio" value="Yes" v-model="data.multiple_revenue" checked class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" />
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>
                            <div class="flex items-center">
                              <input id="no" name="notification-method" type="radio" value="No" v-model="data.multiple_revenue" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" />
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="howmany"
                        >
                          <span class="text-red-400">*</span>
                          If so, how many?
                        </label>
                        <input
                          id="howmany"
                          name="howmany"
                          type="number"
                          :class="[
                          v$.total.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="e.g 20% to food delivery, 80% to ride sharing"
                          style="transition: 'all .15s ease'"
                          v-model="v$.total.$model"
                          @blur="v$.total.$touch()"
                        />
                        <div v-if="v$.total.$error">
                          <p
                            v-if="v$.total.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >How many streams is required</p>
                          <p
                            v-if="v$.total.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.total.minValueValue.$message}}</p>
                        </div>
                      </div>
                      <div class="percentage-profit relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="percentageprofits"
                        >
                          <span class="text-red-400">*</span>
                          What are the percentage of profits attributed to the different revenue streams? <br/>Must provide at least {{data.total}} revenue streams
                        </label>
                        <div v-for="(percentageProfit, index) in data.percentage_profit" :key="index" class="flex flex-col">
                          <div class="grid md:grid-cols-2 grid-cols-1 gap-2 mb-2">
                            <div class="name md:mr-2 mr-0">
                              <label
                                class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                                for="revenue-name"
                              >
                                REVENUE STREAM
                                <span class="">[{{index + 1}}]</span>
                              </label>
                              <input
                                id="revenue-name"
                                name="revenue-name"
                                type="text"
                                :class="[
                                  (v$.percentage_profit.$each.$response.$data[index].name.$error && v$.percentage_profit.$dirty) ? 'border-red-400' : 'border-borderGray',
                                ]"
                                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border  rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                placeholder="Eg Food delivery service"
                                style="transition: 'all .15s ease'"
                                @blur="v$.percentage_profit.$touch()"
                                v-model="v$.percentage_profit.$model[index].name"
                              />
                              <div v-if="v$.percentage_profit.$each.$response.$data[index].name.$error && v$.percentage_profit.$dirty">
                                <p
                                  v-if="!v$.percentage_profit.$each.$response.$data[index].name.required && v$.percentage_profit.$each.$response.$data[index].name.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Revenue stream is required</p>
                                <p
                                v-if="!v$.percentage_profit.$each.$response.$data[index].name.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Revenue stream should be at least 3 characters long</p>
                              </div>
                            </div>
                            <div class="profits">
                              <label
                                class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                                for="profit-percentage"
                              >
                                <!-- <span class="text-red-400">*</span> -->
                                PROFIT in (%)
                              </label>
                              <div class="relative">
                                <span v-if="index > 0" @click="removeField(data.percentage_profit, index)" class="absolute inset-y-0 right-0 top-0 bottom-0 flex items-center pr-4 mt-2">
                                  <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                  </svg>
                                </span>
                                <input
                                  id="profit-percentage"
                                  name="profit-percentage"
                                  type="number"
                                  min="1"
                                  :class="[
                                    (v$.percentage_profit.$each.$response.$data[index].percentage.$error && v$.percentage_profit.$dirty) ? 'border-red-400' : 'border-borderGray',
                                  ]"
                                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                  placeholder="20"
                                  style="transition: 'all .15s ease'"
                                  @blur="v$.percentage_profit.$touch()"
                                  v-model="v$.percentage_profit.$model[index].percentage"
                                />
                                <div v-if="v$.percentage_profit.$each.$response.$data[index].percentage.$error && v$.percentage_profit.$dirty">
                                  <p
                                    v-if="!v$.percentage_profit.$each.$response.$data[index].percentage.$required && v$.percentage_profit.$each.$response.$data[index].percentage.betweenValue"
                                    class="text-red-400 text-[10px] font-light"
                                  >Percentage profit is required</p>
                                <p
                                  v-if="!v$.percentage_profit.$each.$response.$data[index].percentage.$required && !v$.percentage_profit.$each.$response.$data[index].percentage.betweenValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Value should be between 0 and 100</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button @click="addNewRevenuePercentageField(data.percentage_profit)" :disabled="v$.percentage_profit.$each.$response.$data.length === data.total" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another revenue stream</p>
                        </button>
                      </div>
                      <div class="percentage-cost relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="percentagecosts"
                        >
                          <span class="text-red-400">*</span>
                          What are the percentage of costs attributed to the different revenue streams? <br/>Must provide at least {{data.total}} revenue streams
                        </label>
                        <div v-for="(percentageCost, index) in data.percentage_cost" :key="index" class="flex flex-col">
                          <div class="grid md:grid-cols-2 grid-cols-1 gap-2 mb-2">
                            <div class="name md:mr-2 mr-0">
                              <label
                                class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                                for="revenue-name"
                              >
                                REVENUE STREAM
                                <span>[{{index + 1}}]</span>
                              </label>
                              <input
                                id="revenue-name"
                                name="revenue-name"
                                type="text"
                                :class="[
                                  (v$.percentage_cost.$each.$response.$data[index].name.$error && v$.percentage_cost.$dirty) ? 'border-red-400' : 'border-borderGray',
                                ]"
                                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                placeholder="Eg Crypto asset trades"
                                style="transition: 'all .15s ease'"
                                @blur="v$.percentage_cost.$touch()"
                                v-model="v$.percentage_cost.$model[index].name"
                              />
                              <div v-if="v$.percentage_cost.$each.$response.$data[index].name.$error && v$.percentage_cost.$dirty">
                                <p
                                  v-if="!v$.percentage_cost.$each.$response.$data[index].name.required && v$.percentage_cost.$each.$response.$data[index].name.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Revenue stream is required</p>
                                <p
                                v-if="!v$.percentage_cost.$each.$response.$data[index].name.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Revenue stream should be at least 3 characters long</p>
                              </div>
                            </div>
                            <div class="profits">
                              <label
                                class="font-Rubik text-greyText text-[11px] leading-[13.04px] font-normal"
                                for="profit-percentage"
                              >
                                <!-- <span class="text-red-400">*</span> -->
                                COST in (%)
                              </label>
                              <div class="relative">
                                <span v-if="index > 0" @click="removeField(data.percentage_cost, index)" class="absolute inset-y-0 right-0 top-0 bottom-0 flex items-center pr-4 mt-2">
                                  <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                  </svg>
                                </span>
                                <input
                                  id="cost-percentage"
                                  name="cost-percentage"
                                  type="number"
                                  min="1"
                                  :class="[
                                    (v$.percentage_cost.$each.$response.$data[index].percentage.$error && v$.percentage_cost.$dirty) ? 'border-red-400' : 'border-borderGray',
                                  ]"
                                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                  placeholder="Cost percentage of stated revenue stream"
                                  style="transition: 'all .15s ease'"
                                  @blur="v$.percentage_cost.$touch()"
                                  v-model="v$.percentage_cost.$model[index].percentage"
                                />
                                <div v-if="v$.percentage_cost.$each.$response.$data[index].percentage.$error && v$.percentage_cost.$dirty">
                                  <p
                                    v-if="!v$.percentage_cost.$each.$response.$data[index].percentage.$required && v$.percentage_cost.$each.$response.$data[index].percentage.betweenValue"
                                    class="text-red-400 text-[10px] font-light"
                                  >Percentage profit is required</p>
                                <p
                                  v-if="!v$.percentage_cost.$each.$response.$data[index].percentage.$required && !v$.percentage_cost.$each.$response.$data[index].percentage.betweenValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Value should be between 0 and 100</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button @click="addNewRevenuePercentageField(data.percentage_cost)" :disabled="v$.percentage_cost.$each.$response.$data.length === data.total" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another revenue stream</p>
                        </button>
                      </div>
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="unit-economics"
                        >
                          <span class="text-red-400">*</span>
                          What is the unit economics of the business?
                        </label>
                        <textarea
                          id="unit-economics"
                          name="unit-economics"
                          type="text"
                          rows="3"
                          :class="[
                          v$.unit_economics.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Briefly tell us how you analyze the company’s cost to revenue ratio in relation to a single unit"
                          style="transition: 'all .15s ease'"
                          v-model="v$.unit_economics.$model"
                          @blur="v$.unit_economics.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.unit_economics.length} of 400`}}</span>
                        <div v-if="v$.unit_economics.$error">
                          <p
                            v-if="v$.unit_economics.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Unit economics is required</p>
                          <p
                            v-if="v$.unit_economics.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Unit economics should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep1">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Financials') || (v$.percentage_profit.$each.$response.$data.length !== data.total || v$.percentage_cost.$each.$response.$data.length !== data.total)" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep1">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center md:bg-[transparent] bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Financials') || (v$.percentage_profit.$each.$response.$data.length !== data.total || v$.percentage_cost.$each.$response.$data.length !== data.total)" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="meetingTime"
                        >
                          <span class="text-red-400">*</span>
                          Schedule time to speak with the Kinfolk team
                        </label>
                        <div class="mt-4 flex items-center">
                          <Switch
                            v-model="enabled"
                            :disabled="calenderLoaded"
                            :class="enabled ? 'bg-black' : 'bg-lineGray'"
                            class="relative inline-flex flex-shrink-0 h-[31px] w-[51px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                          >
                            <span class="sr-only">Use setting</span>
                            <span
                              aria-hidden="true"
                              :class="enabled ? 'translate-x-5' : 'translate-x-0'"
                              class="pointer-events-none inline-block h-[27px] w-[27px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                            />
                          </Switch>
                          <p class="ml-4 text-black font-Rubik text-[15px] leading-[17.78px]">Schedule meeting time</p>
                        </div>
                        <svg v-if="enabled && !calenderLoaded" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="35px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                          <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                          </circle>
                        </svg>
                        <div id="calender" class="h-[600px] mt-1"></div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep2">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="!schedule_meeting" @click="onSubmit" class="flex bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                            <span :class="submitloading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                            <svg v-if="submitloading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                              <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                              </circle>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep2">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="!schedule_meeting" @click="onSubmit" class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                          <span :class="submitloading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                          <svg v-if="submitloading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                            </circle>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_five === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_five ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { Switch } from '@headlessui/vue'
import industries from '@/utils/industries'
import businessmodel from '@/utils/businessmodels'
import fundinground from '@/utils/fundinground'
import fundingtype from '@/utils/fundingtype'
import useVuelidate from '@vuelidate/core'
import { required, url, minValue, helpers, between, minLength } from '@vuelidate/validators'
import { useStore } from 'vuex'
import FileService from '@/services/file.service'
import Helpers from '../../utils/helpers'
import StageFiveService from '@/services/stagefive.service'
import CompanyService from '@/services/company.service'
import store from '@/store'
import DraftService from '@/services/draft.service'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}

export default {
  components: {
    Switch
  },
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    let current = 2
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })

    const selectedIndustry = ref(industries[0])
    const selectedModel = ref(businessmodel[0])
    const selectedRound = ref(fundinground[0])
    const selectedType = ref(fundingtype[0])
    const financialModelFile = ref(true)
    const submitloading = ref(false)
    // const progress = reactive({
    //   stage1: true,
    //   stage2: false,
    //   stage3: true
    // })
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })
    const enabled = ref(false)

    const schedule_meeting = ref(false)
    const calenderLoaded = ref(false)
    const windowWidth = ref(window.innerWidth)

    // const onWidthChange = () => {
    //   windowWidth.value = window.innerWidth
    // }
    // console.log(windowWidth.value)

    // onMounted(() => {
    //   window.addEventListener('resize', onWidthChange)
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('resize', onWidthChange)
    // })

    function isCalendlyEvent (e) {
      return e.data.event && e.data.event.indexOf('calendly') === 0
    }

    const getCalendar = () => {
      const name = store.state.app.company.company_name
      const email = store.state.auth.user.email
      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url: process.env.VUE_APP_CALENDLY_URL,
        parentElement: document.getElementById('calender'),
        prefill: {
          name: name,
          email: email
        },
        utm: {}
      })
    }

    const goToStep2 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.33%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep1 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '0%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep3 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-66.66%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep2 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.33%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const data = reactive({
      customer_aquisition: '',
      customer_value: '',
      financial_model_file_upload: '',
      financial_assumptions: '',
      profitability: '',
      churn_rate: '',
      burn_rate: '',
      cash_on_hand: '',
      runway: '',
      multiple_revenue: 'Yes',
      total: '',
      percentage_profit: [
        {
          name: '',
          percentage: ''
        }
      ],
      percentage_cost: [
        {
          name: '',
          percentage: ''
        }
      ],
      unit_economics: ''
    })

    const rules = computed(() => ({
      customer_aquisition: { required, minLengthValue: minLength(3) },
      customer_value: { required, minLengthValue: minLength(3) },

      financial_assumptions: { required, minLengthValue: minLength(3) },
      profitability: { required, minLengthValue: minLength(3) },
      churn_rate: { required, minLengthValue: minLength(3) },
      burn_rate: {
        required,
        minValueValue: minValue(0),
        minLengthValue: minLength(1)
      },
      cash_on_hand: {
        required,
        minValueValue: minValue(0)
      },
      runway: {
        required,
        minValueValue: minValue(0)
      },
      multiple_revenue: { required },
      total: {
        required,
        minValueValue: minValue(0)
      },
      percentage_profit: {
        $each: helpers.forEach({
          name: { required, minLengthValue: minLength(3) },
          percentage: {
            required,
            betweenValue: between(0, 100)
          }
        })
      },
      percentage_cost: {
        $each: helpers.forEach({
          name: { required, minLengthValue: minLength(3) },
          percentage: {
            required,
            betweenValue: between(0, 100)
          }
        })
      },
      unit_economics: { required, minLengthValue: minLength(3) }
    }))

    const v$ = useVuelidate(rules, data)

    const addNewRevenuePercentageField = (arr) => {
      arr.push({
        name: '',
        percentage: ''
      })
    }
    // const addNewPercentageCostField = (arr) => {
    //   arr.push({
    //     name: '',
    //     cost: ''
    //   })
    // }

    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }

    const toggleFinancialModelFile = () => {
      financialModelFile.value = !financialModelFile.value
    }
    const stageFiles = ref({
      financial_model_file_upload: null
    })

    const loading = reactive({
      state: false,
      data: null,
      index: null
    })

    const choosefile = async (event, name, category) => {
      loading.state = true
      loading.data = name
      const company_id = store.state.app.company.id
      if (event.target.files[0]) {
        const file = event.target.files[0]
        const formData = new FormData()
        formData.append('company_id', company_id)
        formData.append('document_type', category)
        formData.append('file', file)

        try {
          const response = await FileService.upload(formData)
          if (response.status === 200 && response.data.status === 'success') {
            loading.state = false
            loading.data = null
            data[name] = response.data.data.file_name
            stageFiles.value[name] = response.data.data.file_name
          }
        } catch (error) {
          loading.state = false
          loading.data = null
        }
      }
    }
    const removefile = (name) => {
      if (name) {
        data[name] = ''
      }
    }

    const checkValidForm = (v$, screen) => {
      switch (screen) {
        case 'Market':
          if (v$.customer_aquisition.$invalid ||
          v$.customer_value.$invalid) {
            return true
          }
          break
        case 'Financials':
          if (v$.financial_assumptions.$invalid ||
          v$.profitability.$invalid ||
          v$.churn_rate.$invalid ||
          v$.burn_rate.$invalid ||
          v$.cash_on_hand.$invalid ||
          v$.runway.$invalid ||
          v$.multiple_revenue.$invalid ||
          v$.total.$invalid ||
          v$.percentage_profit.$invalid ||
          v$.percentage_cost.$invalid ||
          v$.unit_economics.$invalid
          ) {
            return true
          }
          break
        default:
          return false
      }
    }

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 5')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.customer_aquisition = draft.customer_aquisition
          data.customer_value = draft.customer_value
          data.unit_economics = draft.unit_economics
          data.financial_model_file_upload = draft.financial_model_file_upload
          data.financial_assumptions = draft.financial_assumptions
          data.profitability = draft.profitability
          data.churn_rate = draft.churn_rate
          data.burn_rate = draft.burn_rate
          data.cash_on_hand = draft.cash_on_hand
          data.runway = draft.runway
          data.multiple_revenue = draft.multiple_revenue
          data.total = draft.total
          data.percentage_profit = draft.percentage_profit
          data.percentage_cost = draft.percentage_cost
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        customer_aquisition: data.customer_aquisition,
        customer_value: data.customer_value,
        unit_economics: data.unit_economics,
        financial_model_file_upload: data.financial_model_file_upload,
        financial_assumptions: data.financial_assumptions,
        profitability: data.profitability,
        churn_rate: data.churn_rate,
        burn_rate: data.burn_rate,
        cash_on_hand: data.cash_on_hand,
        runway: data.runway,
        multiple_revenue: data.multiple_revenue,
        total: data.total,
        percentage_profit: data.percentage_profit,
        percentage_cost: data.percentage_cost
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 5',
        data: stagedata
      }
      // console.log(draft)
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      submitloading.value = true
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        customer_aquisition: data.customer_aquisition,
        customer_value: data.customer_value,
        unit_economics: data.unit_economics,
        financial_model: Helpers.changeEmptyStringtoNull(data.financial_model_file_upload),
        financial_assumptions: data.financial_assumptions,
        profitabilty: data.profitability,
        churn_rate: data.churn_rate,
        burn_rate: Number(data.burn_rate),
        cash_on_hand: data.cash_on_hand,
        runway: Number(data.runway),
        multiple_revnue: data.multiple_revenue,
        total: data.total,
        percentage_profit: data.percentage_profit,
        percentage_cost: data.percentage_cost
      }
      // console.log(stagedata)

      try {
        const response = await StageFiveService.createStageFive(stagedata)
        if (response.status === 200 && response.data.status === 'success') {
          submitloading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)
          setTimeout(() => {
            store.commit('setSuccess', {
              status: false,
              message: null
            })
          }, 2000)
          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        submitloading.value = false
        Helpers.processError(e, store, router)
      }
      // const success = {
      //   status: true,
      //   message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
      // }
      // store.commit('setSuccess', success)
    }

    onMounted(() => {
      window.addEventListener(
        'message',
        function (e) {
          if (isCalendlyEvent(e)) {
            if (e.data.event === 'calendly.event_scheduled') {
              schedule_meeting.value = true
              const calendar = document.getElementById('calender')
              calendar.style.display = 'none'
            } else if (e.data.event === 'calendly.event_type_viewed') {
              calenderLoaded.value = true
            } else {
              calenderLoaded.value = false
              schedule_meeting.value = false
            }
          }
        }
      )
    })
    watch(() => enabled.value, (value) => {
      if (value === true) {
        getCalendar()
      }
    })

    return {
      route,
      progress: computed(() => store.state.app.progress_status),
      disabled,
      industries,
      selectedIndustry,
      businessmodel,
      selectedModel,
      fundinground,
      selectedRound,
      fundingtype,
      selectedType,
      goToStep2,
      returnToStep1,
      goToStep3,
      returnToStep2,
      enabled,
      data,
      v$,
      addNewRevenuePercentageField,
      removeField,
      url,
      stageFiles,
      toggleFinancialModelFile,
      choosefile,
      removefile,
      financialModelFile,
      checkValidForm,
      loading,
      submitloading,
      getCalendar,
      schedule_meeting,
      calenderLoaded,
      onSubmit,
      windowWidth,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
.contain .form-outer{
  width: 100%;
  overflow: hidden;
}
.contain .form-outer .forms{
  display: flex;
  width: 300%;
}
.form-outer .forms .page{
  width: 33.33%;
  transition: margin-left 0.3s ease-in-out;
}
.contain .progress-bar{
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 60px 5px;
  user-select: none;
}
.contain .progress-bar .step{
  text-align: center;
  position: relative;
}

.progress-bar .step .bullet{
  height: 16px;
  width: 16px;
  background-color: rgba(229, 230, 230, 1);
  display: flex;
  border-radius: 50%;
  position: relative;
  transition: 0.2s;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.progress-bar .step .bullet.active{
  background-color: #000000;
  height: 20px;
  width: 20px;
}
.progress-bar .step .bullet.active + p{
  color: #000000;
}
.progress-bar .step .bullet.active::after {
  content: "";
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: solid 1px white;
  border-radius: 50%;
  position: absolute;
}
.progress .current-progress{
  display: none;
}
.progress .current-progress.active{
  display: flex;
}
</style>
